import { MobileProposalPointInfoType } from "@repo/core/services/entities/MobileProposal";
import { useCreditProposalStore } from "../Credit/store";
import { useFidelityProposalStore } from "../Fidelity/store";

const buildServicePointData = (point: MobileProposalPointInfoType) => ({
  strPontoAtendimento: point.ponto,
  strPontoAntendimentoNome: point.descricao,
  strPontoAtendimentoDescricao: point.descricao
});

export const resolveIsFidelitySelection = (
  routeFlag: unknown,
  storeFlag: boolean
) => routeFlag === true || routeFlag === "true" || storeFlag;

/**
 * Keeps credit/fidelity review summary in sync with the selected service point.
 * Prefers the explicit flow flag, then falls back to whichever flow store is populated
 * (`isFidelityProposal` is not always set when editing from review).
 */
export const syncSelectedServicePointToProposalFlow = (
  point: MobileProposalPointInfoType,
  isFidelityProposal: boolean
) => {
  const servicePointData = buildServicePointData(point);
  const fidelityStore = useFidelityProposalStore.getState();
  const creditStore = useCreditProposalStore.getState();
  const fidelityHasData = Boolean(fidelityStore.proposalData);
  const creditHasData = Boolean(creditStore.proposalData);

  if (isFidelityProposal && fidelityHasData) {
    fidelityStore.updateProposalData(servicePointData);
    return;
  }

  if (!isFidelityProposal && creditHasData) {
    creditStore.updateProposalData(servicePointData);
    return;
  }

  if (fidelityHasData) {
    fidelityStore.updateProposalData(servicePointData);
  }

  if (creditHasData) {
    creditStore.updateProposalData(servicePointData);
  }
};
